import { render, staticRenderFns } from "./DoctorRegisterRecordModal.vue?vue&type=template&id=de345314&scoped=true&"
import script from "./DoctorRegisterRecordModal.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterRecordModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterRecordModal.vue?vue&type=style&index=0&id=de345314&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de345314",
  null
  
)

export default component.exports